import { Component, MouseEvent } from "react";
import Configuration from "config";

interface ActionProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  dataCy?: string;
  // FIXME adding a proper type results in a bunch of errors
  // that are non-obvious to fix - potential bugs
  onClick?: any;
  // FIXME some consumers expect us to support this property.
  // Which we don't...
  disabled?: boolean;
}

export default class Action extends Component<ActionProps> {
  private justClicked: boolean = false;

  private disallowClick = (): void => {
    this.justClicked = true;
    setTimeout(() => {
      this.justClicked = false;
    }, Configuration.ACTION_CLICK_TIMEOUT);
  };

  private onClick = (evt: MouseEvent<HTMLAnchorElement>): boolean | void => {
    if (!this.justClicked) {
      this.disallowClick();
      this.props.onClick?.(evt);
    } else {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  };

  private onDoubleClick = (evt: MouseEvent<HTMLAnchorElement>): boolean | void => {
    if (!this.justClicked) {
      this.disallowClick();
      const clickHandler = this.props.onDoubleClick || this.props.onClick;
      clickHandler?.(evt);
    } else {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  };

  render() {
    const { dataCy, className, ...restProps } = this.props;
    const propsToPass = {
      ...restProps,
      onClick: this.onClick,
      onDoubleClick: this.onDoubleClick,
      className: className ?? "btn",
      "data-cy": dataCy,
    };
    return <a {...propsToPass}>{this.props.children}</a>;
  }
}
